export const enum queryConstants  {

  // list queries
  listQueriesRequest = "LIST_QUERIES_REQUEST",
  listQueriesSuccess = "LIST_QUERIES_SUCCESS",
  listQueriesFailure = "LIST_QUERIES_FAILURE",

  // create/save query
  saveQueryRequest = "SAVE_QUERY_REQUEST",
  saveQuerySuccess = "SAVE_QUERY_SUCCESS",
  saveQueryFailure = "SAVE_QUERY_FAILURE",

  // view query
  viewQueryRequest = "VIEW_QUERY_REQUEST",
  viewQuerySuccess = "VIEW_QUERY_SUCCESS",
  viewQueryFailure = "VIEW_QUERY_FAILURE",

  // delete query
  deleteQueryRequest = "DELETE_QUERY_REQUEST",
  deleteQuerySuccess = "DELETE_QUERY_SUCCESS",
  deleteQueryFailure = "DELETE_QUERY_FAILURE",

  // add remarks
  addRemarksRequest = "ADD_REMARKS_REQUEST",
  addRemarksSuccess = "ADD_REMARKS_SUCCESS",
  addRemarksFailure = "ADD_REMARKS_FAILURE",

};
